import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => !['active', 'iconColor', 'iconSize', 'marginLeft'].includes(prop),
})(({ active, iconColor, iconSize, marginLeft }) => ({
  minWidth: 'auto',
  width: iconSize ? iconSize : 20,
  height: iconSize ? iconSize : 20,
  marginTop: -4,
  marginLeft: marginLeft !== undefined ? marginLeft : 4,
  padding: 0,
  borderRadius: '10%',
  //   backgroundColor: active ? 'rgba(25, 118, 210, 0.12)' : undefined,
  '&:hover': {
    backgroundColor: 'transparent',
  },
  '& svg': {
    width: iconSize ? iconSize : 20,
    height: iconSize ? iconSize : 20,
    color: active ? '#1976d2' : iconColor ? iconColor : '#929292',
    transition: 'color 0.2s',
    padding: 2,
  },
}));

export function CustomIconButton({
  active = false, // 강조(파란색) 상태
  iconColor, // 아이콘 색상
  iconSize, // 아이콘 크기(px)
  marginLeft, // 왼쪽 마진(px)
  children, // 아이콘 컴포넌트
  ...rest // 기타 MUI IconButton props
}) {
  return (
    <StyledIconButton active={active} iconColor={iconColor} iconSize={iconSize} marginLeft={marginLeft} {...rest}>
      {children}
    </StyledIconButton>
  );
}
